import React from "react";
import { t } from "@auto/services";

import styles from "./WelcomePage.module.styl";

export function WelcomePage() {
  return (
    <div className={styles.root}>
      <div className={styles.center}>
        <img
          src="/assets/public/splash.png"
          alt={t("common.splash")}
          className={styles.splash}
        />
      </div>
    </div>
  );
}